// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    documents_find_documents: 'Buscando entre los documentos',
    documents_document_detail: 'Leyendo la ficha de un documento',
    documents_storage_summary: 'Mirando el archivo de documentos',
    documents_create_folder: 'Creando una carpeta',
    documents_move_document: 'Moviendo un documento',
    documents_read_document: 'Leyendo un documento',
  },
  ca: {
    documents_find_documents: 'Cercant entre els documents',
    documents_document_detail: 'Llegint la fitxa d’un document',
    documents_storage_summary: 'Mirant l’arxiu de documents',
    documents_create_folder: 'Creant una carpeta',
    documents_move_document: 'Movent un document',
    documents_read_document: 'Llegint un document',
  },
  en: {
    documents_find_documents: 'Looking through the documents',
    documents_document_detail: 'Reading a document card',
    documents_storage_summary: 'Checking the document store',
    documents_create_folder: 'Creating a folder',
    documents_move_document: 'Moving a document',
    documents_read_document: 'Reading a document',
  },
  fr: {
    documents_find_documents: 'Recherche parmi les documents',
    documents_document_detail: 'Lecture de la fiche d’un document',
    documents_storage_summary: 'Consultation de l’espace documentaire',
    documents_create_folder: 'Création d’un dossier',
    documents_move_document: 'Déplacement d’un document',
    documents_read_document: 'Lecture d’un document',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
